import React from "react";
import config from "../../config";
import GoogleAnalytics from "../GA";

function AboutPortfolio(props) {

    let GA_portfolio = () => {
       // GA4 Btn for portfolio
       GoogleAnalytics('portfolio_onboarding_banner','User');
  
    }
  

    return (
        props.onboarded != null &&
        !props.onboarded && (
        <div className={`aboutPortfolio ${props.style}`}>
            <h3>
            ABOUT PORTFOLIO
            </h3>
            <p>
            Portofolio enables you to showcase the selected credentials as public.
            You will be able to share specific credential or whole resume. All
            information will be easily verifiable.{" "}
            </p>
            <a
            href={config.loginPortfolio}
            target="_blank"
            onClick={() =>{GA_portfolio()}}
            >
            TRY PORTFOLIO
            </a>
        </div>
        )
    );
}

export default AboutPortfolio;
